import { render, staticRenderFns } from "./AddFeatureView.vue?vue&type=template&id=461e0670"
import script from "./AddFeatureView.vue?vue&type=script&lang=ts"
export * from "./AddFeatureView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports